document.addEventListener('DOMContentLoaded', () => {
    const floatingBtn = document.querySelector('.js-scroll-top');
    const footerBtn   = document.querySelector('.js-footer-arrow-up');
    if (!floatingBtn || !footerBtn) return;

    const THRESHOLD = 300;
    let footerVisible = false;

    floatingBtn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    const update = () => {
        const show = window.scrollY > THRESHOLD && !footerVisible;
        floatingBtn.classList.toggle('is-visible', show);
    };

    new IntersectionObserver((entries) => {
        footerVisible = entries[0].isIntersecting;
        update();
    }).observe(footerBtn);

    window.addEventListener('scroll', update, { passive: true });
});
